<template>
  <v-card flat color="section">
    <v-card-title> Outbound </v-card-title>
    <v-card-text>
      Enable or disable what BackNine may send on your behalf
    </v-card-text>
    <v-row class="mx-0 mb-3">
      <v-col cols="12" md="6">
        <div class="checkbox-width">
          <checkbox-field
            v-model="messageClient"
            label="Message Client"
            dense
            class="mt-0"
            hide-details
            data-testid="message-client"
            :success="Boolean(messageClient)"
            readonly
            @click="toggleMessageClient"
          />
        </div>
        <div>
          Automatically send email and text message notifications when your case
          status updates to Submitted, Approved, Active, or when Conversion
          offers become available.
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script setup>
import ConfirmationDialog from "@/dialogs/ConfirmationDialog.vue";
import { useAgentSettingsStore } from "@/stores/agent-settings";
import { useDialogStore } from "@/stores/dialog";
import { storeToRefs } from "pinia";
import { markRaw } from "vue";

const agent = useAgentSettingsStore();
const dialog = useDialogStore();

const { messageClient } = storeToRefs(agent);

function toggleMessageClient() {
  const proposedValue = !messageClient.value;

  const title = `${proposedValue ? "Enable" : "Disable"} Message Client`;
  const subtitle = `${proposedValue ? "Automatically" : "Do not automatically"} send email and text message notifications when your case status updates to Submitted, Approved, Active, or when Conversion offers become available.`;

  dialog.showDialog({
    component: markRaw(ConfirmationDialog),
    title,
    subtitle,
    checkboxText: "Apply to all past cases?",
    func: ({ checkboxChecked }) => {
      let applyToAllPastCases = null;
      if (checkboxChecked) applyToAllPastCases = proposedValue;
      return agent.updateMessageClient(proposedValue, applyToAllPastCases);
    }
  });
}
</script>
